import toast from 'react-hot-toast';

import { BaseApi } from 'src/api/BaseApi';

class ProfileApi extends BaseApi {
  async uploadAvatar(image) {
    const formData = new FormData();
    formData.append('image', image);

    try {
      const response = await this.postRequest('user/uploadavatar', formData);

      if (response.error) {
        toast.error('Error in uploadAvatar:', response.status);
        throw new Error(response.status);
      }

      return response;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      toast.error(`Error in uploadAvatar: ${errorMessage}`);
      throw error;
    }
  }

  async updateUserInfo(firstName, lastName, conPass = null, qwoPass = null) {
    const formData = this.createFormData({
      firstName,
      lastName,
    });

    if (conPass) {
      formData.append('conPass', conPass);
    }

    if (qwoPass) {
      formData.append('qwoPass', qwoPass);
    }

    const response = await this.postRequest('user/updateprofile', formData);

    return response;
  }
}

export const profileApi = new ProfileApi();
